import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useGoogleLogin } from "@react-oauth/google";

import { sendRequest } from "../api";

import "./../styles/google.css";

const WebContext = React.createContext();
export const useGoogleAuthProvider = () => React.useContext(WebContext);

const GoogleAuthProvider = ({ children }) => {
  const login = useGoogleLogin({
    clientId: process.env.GOOGLE_CLIENT_ID,
    onError: handleOAuthError,
    onNonOAuthError: handleOAuthError,
    flow: "auth-code",
    scope: process.env.GOOGLE_OAUTH_SCOPE,
    ux_mode: "redirect",
    redirect_uri: `${process.env.API_BASE_URL}/users/auth/google_oauth2/callback`,
  });

  const handleOAuthError = (error) => {
    console.error(error);
  };

  return (
    <WebContext.Provider value={{ login }}>{children}</WebContext.Provider>
  );
};

export default GoogleAuthProvider;
